/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<rect
				opacity="0.4"
				x="14"
				y="2"
				width="8"
				height="8"
				rx="2"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M2 5.2C2 4.0799 2 3.51984 2.21799 3.09202C2.40973 2.71569 2.71569 2.40973 3.09202 2.21799C3.51984 2 4.07989 2 5.2 2H6.8C7.92011 2 8.48016 2 8.90798 2.21799C9.28431 2.40973 9.59027 2.71569 9.78201 3.09202C10 3.51984 10 4.07989 10 5.2V18.8C10 19.9201 10 20.4802 9.78201 20.908C9.59027 21.2843 9.28431 21.5903 8.90798 21.782C8.48016 22 7.92011 22 6.8 22H5.2C4.07989 22 3.51984 22 3.09202 21.782C2.71569 21.5903 2.40973 21.2843 2.21799 20.908C2 20.4802 2 19.9201 2 18.8V5.2Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M14 17.2C14 16.0799 14 15.5198 14.218 15.092C14.4097 14.7157 14.7157 14.4097 15.092 14.218C15.5198 14 16.0799 14 17.2 14H18.8C19.9201 14 20.4802 14 20.908 14.218C21.2843 14.4097 21.5903 14.7157 21.782 15.092C22 15.5198 22 16.0799 22 17.2V18.8C22 19.9201 22 20.4802 21.782 20.908C21.5903 21.2843 21.2843 21.5903 20.908 21.782C20.4802 22 19.9201 22 18.8 22H17.2C16.0799 22 15.5198 22 15.092 21.782C14.7157 21.5903 14.4097 21.2843 14.218 20.908C14 20.4802 14 19.9201 14 18.8V17.2Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<g opacity="0.12">
				<path
					d="M2 5.2C2 4.0799 2 3.51984 2.21799 3.09202C2.40973 2.71569 2.71569 2.40973 3.09202 2.21799C3.51984 2 4.0799 2 5.2 2H6.8C7.9201 2 8.48016 2 8.90798 2.21799C9.28431 2.40973 9.59027 2.71569 9.78201 3.09202C10 3.51984 10 4.0799 10 5.2V18.8C10 19.9201 10 20.4802 9.78201 20.908C9.59027 21.2843 9.28431 21.5903 8.90798 21.782C8.48016 22 7.9201 22 6.8 22H5.2C4.0799 22 3.51984 22 3.09202 21.782C2.71569 21.5903 2.40973 21.2843 2.21799 20.908C2 20.4802 2 19.9201 2 18.8V5.2Z"
					fill="currentColor"
				/>
				<path
					d="M14 17.2C14 16.0799 14 15.5198 14.218 15.092C14.4097 14.7157 14.7157 14.4097 15.092 14.218C15.5198 14 16.0799 14 17.2 14H18.8C19.9201 14 20.4802 14 20.908 14.218C21.2843 14.4097 21.5903 14.7157 21.782 15.092C22 15.5198 22 16.0799 22 17.2V18.8C22 19.9201 22 20.4802 21.782 20.908C21.5903 21.2843 21.2843 21.5903 20.908 21.782C20.4802 22 19.9201 22 18.8 22H17.2C16.0799 22 15.5198 22 15.092 21.782C14.7157 21.5903 14.4097 21.2843 14.218 20.908C14 20.4802 14 19.9201 14 18.8V17.2Z"
					fill="currentColor"
				/>
			</g>
			<path
				d="M2 5.2C2 4.0799 2 3.51984 2.21799 3.09202C2.40973 2.71569 2.71569 2.40973 3.09202 2.21799C3.51984 2 4.07989 2 5.2 2H6.8C7.92011 2 8.48016 2 8.90798 2.21799C9.28431 2.40973 9.59027 2.71569 9.78201 3.09202C10 3.51984 10 4.07989 10 5.2V18.8C10 19.9201 10 20.4802 9.78201 20.908C9.59027 21.2843 9.28431 21.5903 8.90798 21.782C8.48016 22 7.92011 22 6.8 22H5.2C4.07989 22 3.51984 22 3.09202 21.782C2.71569 21.5903 2.40973 21.2843 2.21799 20.908C2 20.4802 2 19.9201 2 18.8V5.2Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M14 5.2C14 4.07989 14 3.51984 14.218 3.09202C14.4097 2.71569 14.7157 2.40973 15.092 2.21799C15.5198 2 16.0799 2 17.2 2H18.8C19.9201 2 20.4802 2 20.908 2.21799C21.2843 2.40973 21.5903 2.71569 21.782 3.09202C22 3.51984 22 4.07989 22 5.2V6.8C22 7.92011 22 8.48016 21.782 8.90798C21.5903 9.28431 21.2843 9.59027 20.908 9.78201C20.4802 10 19.9201 10 18.8 10H17.2C16.0799 10 15.5198 10 15.092 9.78201C14.7157 9.59027 14.4097 9.28431 14.218 8.90798C14 8.48016 14 7.92011 14 6.8V5.2Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M14 17.2C14 16.0799 14 15.5198 14.218 15.092C14.4097 14.7157 14.7157 14.4097 15.092 14.218C15.5198 14 16.0799 14 17.2 14H18.8C19.9201 14 20.4802 14 20.908 14.218C21.2843 14.4097 21.5903 14.7157 21.782 15.092C22 15.5198 22 16.0799 22 17.2V18.8C22 19.9201 22 20.4802 21.782 20.908C21.5903 21.2843 21.2843 21.5903 20.908 21.782C20.4802 22 19.9201 22 18.8 22H17.2C16.0799 22 15.5198 22 15.092 21.782C14.7157 21.5903 14.4097 21.2843 14.218 20.908C14 20.4802 14 19.9201 14 18.8V17.2Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				d="M5.25 1.25C3.84987 1.25 3.1498 1.25 2.61502 1.52248C2.14462 1.76217 1.76217 2.14462 1.52248 2.61502C1.25 3.1498 1.25 3.84987 1.25 5.25V18.75C1.25 20.1501 1.25 20.8502 1.52248 21.385C1.76217 21.8554 2.14462 22.2378 2.61502 22.4775C3.1498 22.75 3.84987 22.75 5.25 22.75H6.75C8.15013 22.75 8.8502 22.75 9.38498 22.4775C9.85538 22.2378 10.2378 21.8554 10.4775 21.385C10.75 20.8502 10.75 20.1501 10.75 18.75V5.25C10.75 3.84987 10.75 3.1498 10.4775 2.61502C10.2378 2.14462 9.85538 1.76217 9.38498 1.52248C8.8502 1.25 8.15013 1.25 6.75 1.25H5.25Z"
				fill="currentColor"
			/>
			<path
				d="M13.25 5.25C13.25 3.84987 13.25 3.1498 13.5225 2.61502C13.7622 2.14462 14.1446 1.76217 14.615 1.52248C15.1498 1.25 15.8499 1.25 17.25 1.25H18.75C20.1501 1.25 20.8502 1.25 21.385 1.52248C21.8554 1.76217 22.2378 2.14462 22.4775 2.61502C22.75 3.1498 22.75 3.84987 22.75 5.25V6.75C22.75 8.15013 22.75 8.8502 22.4775 9.38498C22.2378 9.85538 21.8554 10.2378 21.385 10.4775C20.8502 10.75 20.1501 10.75 18.75 10.75H17.25C15.8499 10.75 15.1498 10.75 14.615 10.4775C14.1446 10.2378 13.7622 9.85538 13.5225 9.38498C13.25 8.8502 13.25 8.15013 13.25 6.75V5.25Z"
				fill="currentColor"
			/>
			<path
				d="M17.25 13.25C15.8499 13.25 15.1498 13.25 14.615 13.5225C14.1446 13.7622 13.7622 14.1446 13.5225 14.615C13.25 15.1498 13.25 15.8499 13.25 17.25V18.75C13.25 20.1501 13.25 20.8502 13.5225 21.385C13.7622 21.8554 14.1446 22.2378 14.615 22.4775C15.1498 22.75 15.8499 22.75 17.25 22.75H18.75C20.1501 22.75 20.8502 22.75 21.385 22.4775C21.8554 22.2378 22.2378 21.8554 22.4775 21.385C22.75 20.8502 22.75 20.1501 22.75 18.75V17.25C22.75 15.8499 22.75 15.1498 22.4775 14.615C22.2378 14.1446 21.8554 13.7622 21.385 13.5225C20.8502 13.25 20.1501 13.25 18.75 13.25H17.25Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M2 10V5.2C2 4.07989 2 3.51984 2.21799 3.09202C2.40973 2.71569 2.71569 2.40973 3.09202 2.21799C3.51984 2 4.07989 2 5.2 2H6.8C7.92011 2 8.48016 2 8.90798 2.21799C9.28431 2.40973 9.59027 2.71569 9.78201 3.09202C10 3.51984 10 4.07989 10 5.2V18.8C10 19.9201 10 20.4802 9.78201 20.908C9.59027 21.2843 9.28431 21.5903 8.90798 21.782C8.48016 22 7.92011 22 6.8 22H5.2C4.07989 22 3.51984 22 3.09202 21.782C2.71569 21.5903 2.40973 21.2843 2.21799 20.908C2 20.4802 2 19.9201 2 18.8V14M19 2H17.2C16.0799 2 15.5198 2 15.092 2.21799C14.7157 2.40973 14.4097 2.71569 14.218 3.09202C14 3.51984 14 4.07989 14 5.2V6.8C14 7.92011 14 8.48016 14.218 8.90798C14.4097 9.28431 14.7157 9.59027 15.092 9.78201C15.5198 10 16.0799 10 17.2 10H18.8C19.9201 10 20.4802 10 20.908 9.78201C21.2843 9.59027 21.5903 9.28431 21.782 8.90798C22 8.48016 22 7.9201 22 6.8V5M17.2 22H18.8C19.9201 22 20.4802 22 20.908 21.782C21.2843 21.5903 21.5903 21.2843 21.782 20.908C22 20.4802 22 19.9201 22 18.8V17.2C22 16.0799 22 15.5198 21.782 15.092C21.5903 14.7157 21.2843 14.4097 20.908 14.218C20.4802 14 19.9201 14 18.8 14H17.2C16.0799 14 15.5198 14 15.092 14.218C14.7157 14.4097 14.4097 14.7157 14.218 15.092C14 15.5198 14 16.0799 14 17.2V18.8C14 19.9201 14 20.4802 14.218 20.908C14.4097 21.2843 14.7157 21.5903 15.092 21.782C15.5198 22 16.0799 22 17.2 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M2 5.2C2 4.0799 2 3.51984 2.21799 3.09202C2.40973 2.71569 2.71569 2.40973 3.09202 2.21799C3.51984 2 4.07989 2 5.2 2H6.8C7.92011 2 8.48016 2 8.90798 2.21799C9.28431 2.40973 9.59027 2.71569 9.78201 3.09202C10 3.51984 10 4.07989 10 5.2V18.8C10 19.9201 10 20.4802 9.78201 20.908C9.59027 21.2843 9.28431 21.5903 8.90798 21.782C8.48016 22 7.92011 22 6.8 22H5.2C4.07989 22 3.51984 22 3.09202 21.782C2.71569 21.5903 2.40973 21.2843 2.21799 20.908C2 20.4802 2 19.9201 2 18.8V5.2Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M14 5.2C14 4.07989 14 3.51984 14.218 3.09202C14.4097 2.71569 14.7157 2.40973 15.092 2.21799C15.5198 2 16.0799 2 17.2 2H18.8C19.9201 2 20.4802 2 20.908 2.21799C21.2843 2.40973 21.5903 2.71569 21.782 3.09202C22 3.51984 22 4.07989 22 5.2V6.8C22 7.92011 22 8.48016 21.782 8.90798C21.5903 9.28431 21.2843 9.59027 20.908 9.78201C20.4802 10 19.9201 10 18.8 10H17.2C16.0799 10 15.5198 10 15.092 9.78201C14.7157 9.59027 14.4097 9.28431 14.218 8.90798C14 8.48016 14 7.92011 14 6.8V5.2Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M14 17.2C14 16.0799 14 15.5198 14.218 15.092C14.4097 14.7157 14.7157 14.4097 15.092 14.218C15.5198 14 16.0799 14 17.2 14H18.8C19.9201 14 20.4802 14 20.908 14.218C21.2843 14.4097 21.5903 14.7157 21.782 15.092C22 15.5198 22 16.0799 22 17.2V18.8C22 19.9201 22 20.4802 21.782 20.908C21.5903 21.2843 21.2843 21.5903 20.908 21.782C20.4802 22 19.9201 22 18.8 22H17.2C16.0799 22 15.5198 22 15.092 21.782C14.7157 21.5903 14.4097 21.2843 14.218 20.908C14 20.4802 14 19.9201 14 18.8V17.2Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<g opacity="0.32">
				<path
					d="M13.25 5.25C13.25 3.84987 13.25 3.1498 13.5225 2.61502C13.7622 2.14462 14.1446 1.76217 14.615 1.52248C15.1498 1.25 15.8499 1.25 17.25 1.25H18.75C20.1501 1.25 20.8502 1.25 21.385 1.52248C21.8554 1.76217 22.2378 2.14462 22.4775 2.61502C22.75 3.1498 22.75 3.84987 22.75 5.25V6.75C22.75 8.15013 22.75 8.8502 22.4775 9.38498C22.2378 9.85538 21.8554 10.2378 21.385 10.4775C20.8502 10.75 20.1501 10.75 18.75 10.75H17.25C15.8499 10.75 15.1498 10.75 14.615 10.4775C14.1446 10.2378 13.7622 9.85538 13.5225 9.38498C13.25 8.8502 13.25 8.15013 13.25 6.75V5.25Z"
					fill="currentColor"
				/>
				<path
					d="M17.25 13.25C15.8499 13.25 15.1498 13.25 14.615 13.5225C14.1446 13.7622 13.7622 14.1446 13.5225 14.615C13.25 15.1498 13.25 15.8499 13.25 17.25V18.75C13.25 20.1501 13.25 20.8502 13.5225 21.385C13.7622 21.8554 14.1446 22.2378 14.615 22.4775C15.1498 22.75 15.8499 22.75 17.25 22.75H18.75C20.1501 22.75 20.8502 22.75 21.385 22.4775C21.8554 22.2378 22.2378 21.8554 22.4775 21.385C22.75 20.8502 22.75 20.1501 22.75 18.75V17.25C22.75 15.8499 22.75 15.1498 22.4775 14.615C22.2378 14.1446 21.8554 13.7622 21.385 13.5225C20.8502 13.25 20.1501 13.25 18.75 13.25H17.25Z"
					fill="currentColor"
				/>
			</g>
			<path
				d="M5.25 1.25C3.84987 1.25 3.1498 1.25 2.61502 1.52248C2.14462 1.76217 1.76217 2.14462 1.52248 2.61502C1.25 3.1498 1.25 3.84987 1.25 5.25V18.75C1.25 20.1501 1.25 20.8502 1.52248 21.385C1.76217 21.8554 2.14462 22.2378 2.61502 22.4775C3.1498 22.75 3.84987 22.75 5.25 22.75H6.75C8.15013 22.75 8.8502 22.75 9.38498 22.4775C9.85538 22.2378 10.2378 21.8554 10.4775 21.385C10.75 20.8502 10.75 20.1501 10.75 18.75V5.25C10.75 3.84987 10.75 3.1498 10.4775 2.61502C10.2378 2.14462 9.85538 1.76217 9.38498 1.52248C8.8502 1.25 8.15013 1.25 6.75 1.25H5.25Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
